import React, { useState } from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import MenuBar from "../../../components/MenuBar";
import HeaderBar from "../../../components/HeaderBar";
import { ADMIN_NAV, FA_SIDEBAR_WIDTH_KEY } from "../constants";
import { useFirestoreAdminTheme } from "../hooks/useFirestoreAdminTheme";
import { useFirestoreAdmin } from "../context/FirestoreAdminProvider";
import FirestoreAdminStatusBar from "./FirestoreAdminStatusBar";
import FirestoreManagerWorkspaceBar from "./FirestoreManagerWorkspaceBar";
import "../styles/firestoreAdmin.css";

export default function FirestoreAdminLayout() {
  const { dark, toggle } = useFirestoreAdminTheme();
  const { roleLabel, user } = useFirestoreAdmin();
  const [collapsed, setCollapsed] = useState(false);
  const [sidebarWidth, setSidebarWidth] = useState(() => {
    const w = Number(localStorage.getItem(FA_SIDEBAR_WIDTH_KEY));
    return w >= 200 && w <= 400 ? w : 260;
  });

  const onResizeStart = (e) => {
    e.preventDefault();
    const startX = e.clientX;
    const startW = sidebarWidth;
    const onMove = (ev) => {
      const next = Math.min(400, Math.max(200, startW + ev.clientX - startX));
      setSidebarWidth(next);
      localStorage.setItem(FA_SIDEBAR_WIDTH_KEY, String(next));
    };
    const onUp = () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
    };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
  };

  return (
    <div className="flex min-h-screen flex-col">
      <MenuBar />
      <HeaderBar />
      <div
        className={`fa-root${dark ? " fa-dark" : ""}`}
        style={{ "--fa-sidebar-width": collapsed ? "72px" : `${sidebarWidth}px` }}
      >
        <div className="fa-shell">
          <aside className={`fa-sidebar relative ${collapsed ? "fa-sidebar-collapsed" : ""}`}>
            <div className="mb-3 flex items-center justify-between gap-2 px-2">
              {!collapsed && (
                <div>
                  <p className="text-xs font-bold uppercase tracking-wide text-indigo-600">Admin Console</p>
                  <p className="text-[11px] text-slate-500">{roleLabel}</p>
                </div>
              )}
              <button type="button" className="fa-btn" onClick={() => setCollapsed((v) => !v)} title="Toggle sidebar">
                {collapsed ? "»" : "«"}
              </button>
            </div>
            <nav>
              {ADMIN_NAV.map((item) => (
                <NavLink
                  key={item.id}
                  to={item.path || "."}
                  end={item.path === ""}
                  className={({ isActive }) => `fa-nav-link${isActive ? " active" : ""}`}
                  title={item.label}
                >
                  <span className="material-symbols-outlined text-[18px]">{item.icon}</span>
                  {!collapsed && <span>{item.label}</span>}
                </NavLink>
              ))}
            </nav>
            {!collapsed && (
              <div className="mt-4 border-t border-slate-200 pt-3 px-2 text-xs text-slate-500">
                <p className="truncate font-medium text-slate-700">{user?.email}</p>
                <Link to="/admin" className="mt-2 inline-block text-indigo-600 hover:underline">
                  ← Admin panel
                </Link>
              </div>
            )}
            {!collapsed && (
              <div
                role="separator"
                onMouseDown={onResizeStart}
                className="absolute right-0 top-0 h-full w-1 cursor-col-resize hover:bg-indigo-300"
              />
            )}
          </aside>
          <div className="flex min-h-0 flex-col">
            <div className="fa-main flex-1">
              <div className="mb-3 flex justify-end">
                <button type="button" className="fa-btn" onClick={toggle}>
                  <span className="material-symbols-outlined text-[18px]">
                    {dark ? "light_mode" : "dark_mode"}
                  </span>
                  {dark ? "Light" : "Dark"}
                </button>
              </div>
              <FirestoreManagerWorkspaceBar />
              <Outlet />
            </div>
            <FirestoreAdminStatusBar />
          </div>
        </div>
      </div>
    </div>
  );
}
